// src/catalog/components/detail/CatalogEntryAdaptationSelector.jsx

import { ApplicationOptionSelector } from "../../../components/application";
import {
  CAPEVAdaptationHelp,
  getCapeVrEquivalentSlugForRecommendation,
} from "../../../activities/cape-v/CAPEVControlContextualHelp";
import {
  getCAPEVAdaptationOptions,
  getCatalogEntryCAPEVAvailableAdaptations,
  getDefaultCAPEVAdaptationId,
  shouldRenderCAPEVAdaptationSelector
} from "../../../activities/cape-v/capevAdaptations";

export default function CatalogEntryAdaptationSelector({
  entry,
  selectedAdaptationId,
  onChange,
  onOpenRelatedEntry
}) {
  if (!shouldRenderCAPEVAdaptationSelector(entry)) {
    return null;
  }

  const options = getCAPEVAdaptationOptions(
    getCatalogEntryCAPEVAvailableAdaptations(entry)
  );

  const fallbackAdaptationId = getDefaultCAPEVAdaptationId(entry);
  const selectedOption =
    options.find((option) => option.id === selectedAdaptationId) ||
    options.find((option) => option.id === fallbackAdaptationId) ||
    options[0];

  if (!selectedOption) {
    return null;
  }

  const capeVrEquivalentSlug =
    getCapeVrEquivalentSlugForRecommendation(
      entry,
      selectedOption.id
    );

  return (
    <ApplicationOptionSelector
      id={`catalog-adaptation-${entry.slug}`}
      label="CAPE-V adaptation"
      labelAside={(
        <CAPEVAdaptationHelp
          capeVrCatalogTo={
            capeVrEquivalentSlug
              ? `/app/catalog/${capeVrEquivalentSlug}`
              : null
          }
        />
      )}
      value={selectedOption.id}
      onChange={onChange}
      options={options.map((option) => ({
        value: option.id,
        label: option.label
      }))}
    />
  );
}
